<template>
    <div>
        <!--<h4 class="title is-4">{{ title }}</h4>-->

        <div class="block">
            <div class="field is-grouped is-grouped-right">
                <p v-if="isDeleteSelectedButtonVisible" class="control">
                    <a @click.prevent="confirmCustomDelete" class="button is-danger is-small">Delete selected</a>
                </p>
                <p class="control">
                    <a @click.prevent="openModal(null)" class="button is-info"><span class="icon"><i class="icm-new"></i></span><span>Add Entry</span></a>
                </p>
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <o-table
                        :data="items"
                        :bordered="table.bordered"
                        :striped="table.striped"
                        :narrowed="table.narrowed"
                        :checkable="table.checkable"
                        :mobile-cards="table.mobileCards"
                        :paginated="table.paginated"
                        :pagination-simple="table.paginationSimple"
                        :per-page="table.perPage"
                        :default-sort-direction="table.defaultSortDirection"
                        :default-sort="table.defaultSort"
                        :selected.sync="selected"
                        :checked-rows="checkedRows"
                        @update:checkedRows="$event => checkedRows = $event"
                >
                    <template>
                        <o-table-column #default="{ row }" field="name" label="Name" sortable>
                            {{ row.name }}
                        </o-table-column>

                        <o-table-column #default="{ row }" field="predefined" label="Predefined" sortable>
                            {{ row.predefined ? 'Yes' : 'No' }}
                        </o-table-column>

                        <o-table-column #default="{ row }">
                            <o-dropdown v-if="!row.predefined" hoverable position="bottom-left" class="table-actions">
                                <button class="button" slot="trigger">
                                    <o-icon pack="fa" icon="ellipsis-v"></o-icon>
                                </button>
                                <o-dropdown-item has-link><a @click="openModal(row)">Edit</a></o-dropdown-item>
                                <o-dropdown-item has-link><a @click="confirmCustomDelete(row)">Delete</a></o-dropdown-item>
                            </o-dropdown>
                        </o-table-column>
                    </template>

                  <template #empty>
                    <div class="has-text-centered">
                      This table is empty!
                    </div>
                  </template>
                </o-table>
            </div>
        </div>

       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isModalActive" has-modal-card>
            <dictionary-entry :item="currentItem" />
        </o-modal>
    </div>
</template>

<script>
    import Table from './../mixins/Table'
    import {mapGetters, mapActions} from 'vuex'
    import DictionaryEntry from './modals/DictionaryEntry'

    export default {
        mixins: [Table],

        components: {
            DictionaryEntry
        },

        props: ['type'],

        data() {
            return {
                isModalActive: false,
                currentItem: null
            }
        },

        computed: {
            ...mapGetters(['dictionaryEntriesByType']),

            items() {
                return this.dictionaryEntriesByType(this.type)
            },

            title() {
                return _.startCase(this.type) + ' Dictionary'
            }
        },

        methods: {
            ...mapActions({
                removeItem: 'removeDictionaryEntry'
            }),

            openModal(entry = null) {
                this.currentItem = entry ? entry : {dictionary: this.type, name: ''}
                this.isModalActive = true
            }
        }
    }
</script>